var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3074 7.62288L20.685 6.54279C20.1584 5.62887 18.9914 5.31359 18.0763 5.83798V5.83798C17.6406 6.09461 17.1208 6.16742 16.6314 6.04035C16.1421 5.91329 15.7233 5.59678 15.4676 5.16064C15.303 4.88342 15.2146 4.56766 15.2113 4.24531V4.24531C15.2261 3.72849 15.0311 3.22767 14.6708 2.85694C14.3104 2.4862 13.8153 2.27713 13.2982 2.27734H12.0442C11.5377 2.27734 11.052 2.47918 10.6947 2.83821C10.3374 3.19724 10.1379 3.68386 10.1403 4.19039V4.19039C10.1253 5.23619 9.27321 6.07608 8.2273 6.07597C7.90494 6.07262 7.58919 5.98421 7.31197 5.81968V5.81968C6.39679 5.29528 5.22985 5.61056 4.70327 6.52448L4.03508 7.62288C3.50914 8.53566 3.82013 9.70187 4.73073 10.2316V10.2316C5.32263 10.5733 5.68726 11.2049 5.68726 11.8883C5.68726 12.5718 5.32263 13.2033 4.73073 13.5451V13.5451C3.82129 14.0712 3.50996 15.2346 4.03508 16.1446V16.1446L4.66666 17.2339C4.91338 17.679 5.32734 18.0076 5.81693 18.1467C6.30652 18.2859 6.83137 18.2242 7.27535 17.9753V17.9753C7.71181 17.7206 8.23192 17.6508 8.72007 17.7815C9.20822 17.9121 9.62397 18.2323 9.8749 18.6709C10.0394 18.9482 10.1278 19.2639 10.1312 19.5863V19.5863C10.1312 20.6428 10.9877 21.4993 12.0442 21.4993H13.2982C14.3512 21.4993 15.2062 20.6484 15.2113 19.5954V19.5954C15.2088 19.0873 15.4096 18.5993 15.7689 18.24C16.1282 17.8807 16.6162 17.6799 17.1243 17.6824C17.4459 17.691 17.7604 17.779 18.0397 17.9387V17.9387C18.9524 18.4646 20.1186 18.1536 20.6484 17.243V17.243L21.3074 16.1446C21.5625 15.7068 21.6325 15.1853 21.5019 14.6956C21.3714 14.206 21.051 13.7886 20.6117 13.5359V13.5359C20.1725 13.2832 19.8521 12.8658 19.7215 12.3762C19.591 11.8866 19.661 11.3651 19.9161 10.9272C20.082 10.6376 20.3221 10.3975 20.6117 10.2316V10.2316C21.5169 9.70216 21.8271 8.54276 21.3074 7.63203V7.63203V7.62288Z",
    stroke: "#605BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6752,
    cy: 11.8901,
    r: 2.63616,
    stroke: "#605BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingPurple);
export default __webpack_public_path__ + "static/media/setting-purple.f7102b71ffb44a5aaf773c030248b54f.svg";
export { ForwardRef as ReactComponent };